import "./nota-fiscal.scss";
import React, { useState } from "react";
import { FileSpreadsheet, ClipboardList, ShieldAlert } from "lucide-react";

import ReceiptList from "../../../components/receipts/receipts";
import ReceiptsOrders from "../../../components/receipts/orders";
import ReceiptsBlocked from "../../../components/receipts/blocked";

import { PillTabs } from "../../../components/ui";

type TabKey = "ordens" | "status" | "bloqueados";

const Receipts: React.FC = () => {
    const [activeTab, setActiveTab] = useState<TabKey>("ordens");

    return (
        <div className="nota-fiscal-wrapper">

            <h1 className="page-title">
                Nota Fiscal
                <small>gerenciamento de notas fiscais e ordens.</small>
            </h1>

            <div style={{ marginBottom: 22 }}>
                <PillTabs
                    ariaLabel="Visualizacao de notas fiscais"
                    value={activeTab}
                    onChange={(k: string) => setActiveTab(k as TabKey)}
                    tabs={[
                        { key: "ordens",     label: "Adicao de Ordens",   icon: ClipboardList },
                        { key: "status",     label: "Status das Notas",   icon: FileSpreadsheet },
                        { key: "bloqueados", label: "Bloqueados",         icon: ShieldAlert },
                    ]}
                />
            </div>

            <div className="tab-content">
                {activeTab === "ordens"     && <ReceiptsOrders />}
                {activeTab === "status"     && <ReceiptList />}
                {activeTab === "bloqueados" && <ReceiptsBlocked />}
            </div>
        </div>
    );
};

export default Receipts;
